// apps/web/src/main.tsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { displaySimpleConsoleArt } from './utils/consoleArt';
import { initConsoleProtection, lockdownConsole } from './utils/console-protection';

// Initialize security protections FIRST
initConsoleProtection();
lockdownConsole();

// Display console easter egg for developers
displaySimpleConsoleArt();

// Load security tests in development mode
if (import.meta.env?.DEV) {
  import('./utils/security-test').then(module => {
    console.log('%c🔒 Security Testing Suite Loaded', 'color: #3b82f6; font-weight: bold;');
    console.log('%cType securityTests.runAll() to run all tests', 'color: #8b5cf6;');
    console.log('%cType securityTests.demonstrateAttack() to see a realistic attack', 'color: #8b5cf6;');
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (registration) => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      },
      (err) => {
        console.log('ServiceWorker registration failed: ', err);
      }
    );
  });
}